var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 13.3125V8H10.9375C10.418 8 10 8.41797 10 8.9375V27.0625C10 27.582 10.418 28 10.9375 28H24.0625C24.582 28 25 27.582 25 27.0625V14.25H19.6875C19.1719 14.25 18.75 13.8281 18.75 13.3125ZM21.25 22.5312C21.25 22.7891 21.0391 23 20.7812 23H14.2188C13.9609 23 13.75 22.7891 13.75 22.5312V22.2188C13.75 21.9609 13.9609 21.75 14.2188 21.75H20.7812C21.0391 21.75 21.25 21.9609 21.25 22.2188V22.5312ZM21.25 20.0312C21.25 20.2891 21.0391 20.5 20.7812 20.5H14.2188C13.9609 20.5 13.75 20.2891 13.75 20.0312V19.7188C13.75 19.4609 13.9609 19.25 14.2188 19.25H20.7812C21.0391 19.25 21.25 19.4609 21.25 19.7188V20.0312ZM21.25 17.2188V17.5312C21.25 17.7891 21.0391 18 20.7812 18H14.2188C13.9609 18 13.75 17.7891 13.75 17.5312V17.2188C13.75 16.9609 13.9609 16.75 14.2188 16.75H20.7812C21.0391 16.75 21.25 16.9609 21.25 17.2188ZM25 12.7617V13H20V8H20.2383C20.4883 8 20.7266 8.09766 20.9023 8.27344L24.7266 12.1016C24.9023 12.2773 25 12.5156 25 12.7617Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDefaultIcon);
export default __webpack_public_path__ + "static/media/document-default-icon.e7a7aea33cde2e64639ea4613c34013d.svg";
export { ForwardRef as ReactComponent };